import { render, staticRenderFns } from "./EmailMessageReplyBox.vue?vue&type=template&id=12651933&scoped=true&"
import script from "./EmailMessageReplyBox.vue?vue&type=script&lang=js&"
export * from "./EmailMessageReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageReplyBox.vue?vue&type=style&index=0&id=12651933&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12651933",
  null
  
)

export default component.exports